import { FlowchartNodeDto } from '@treetop/shared/model';

import { IFlowchartNode } from './IFlowchartNode';

export class BasicNode<T extends FlowchartNodeDto> implements Partial<IFlowchartNode> {
  constructor(public element: T) {
    this.element = element;
  }

  setPosition(elementView: joint.dia.ElementView): void {
    this.element.positionX = elementView.model.attributes.position.x;
    this.element.positionY = elementView.model.attributes.position.y;
  }

  setSize(elementView: joint.dia.ElementView): void {
    this.element.width = elementView.model.attributes.size.width;
    this.element.height = elementView.model.attributes.size.height;
  }

  getElement(): T {
    return this.element;
  }

  setPropertiesForInit(element: joint.dia.Cell): void {
    this.element.positionX = element.attributes.position.x;
    this.element.positionY = element.attributes.position.y;
    this.element.width = element.attributes.size.width;
    this.element.height = element.attributes.size.height;
    this.element.id = element.id as string;
    this.element.uniqueId = this.element.id;
  }
}
